<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'shipping-cost-page',
};

</script>
